import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  clearReferralIfExpired,
  resolveReferralCode,
  trackReferralVisit,
} from "../../infrastructure/utils/referralTracking";
import {
  resolveContractorReferralCode,
  storeContractorReferralFallback,
  trackContractorReferralVisit,
} from "../../infrastructure/utils/contractorReferralTracking";

/**
 * Tracks partner referral visits from ?ref= or solarent_ref cookie.
 * Tracks contractor referral from ?contractorRef= / ?cref= (and /c/:code landing).
 * Priority: URL → stored fallback.
 */
const ReferralBootstrap = () => {
  const location = useLocation();
  const trackingRef = useRef(null);
  const contractorTrackingRef = useRef(null);

  useEffect(() => {
    clearReferralIfExpired();

    if (!/^\/r\/[^/?#]+/i.test(location.pathname)) {
      const referralCode = resolveReferralCode({
        search: location.search,
        pathname: location.pathname,
        includeCookie: true,
      });

      if (referralCode) {
        const trackKey = `${referralCode}|${location.pathname}|${location.search}`;
        if (trackingRef.current !== trackKey) {
          trackingRef.current = trackKey;
          trackReferralVisit({
            referralCode,
            search: location.search,
            pathname: location.pathname,
            landingUrl: window.location.href,
          });
        }
      }
    }

    // /c/:code is handled by ContractorReferralLandingPage; still hydrate query-based links.
    if (!/^\/c\/[^/?#]+/i.test(location.pathname)) {
      const contractorCode = resolveContractorReferralCode({
        search: location.search,
      });
      if (contractorCode) {
        const contractorKey = `${contractorCode}|${location.pathname}|${location.search}`;
        if (contractorTrackingRef.current !== contractorKey) {
          contractorTrackingRef.current = contractorKey;
          storeContractorReferralFallback(contractorCode);
          trackContractorReferralVisit({
            referralCode: contractorCode,
            landingUrl: window.location.href,
            channel: "contractor_auth",
          }).catch(() => {
            storeContractorReferralFallback(contractorCode);
          });
        }
      }
    }
  }, [location.pathname, location.search]);

  return <Outlet />;
};

export default ReferralBootstrap;
